// removed by extract-text-webpack-plugin
module.exports = {"privacyPolicyWrap":"qempo_PrivacyPolicy_privacyPolicyWrap-3CN2_GQ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/privacy-policy/components/PrivacyPolicy.scss
// module id = 1919
// module chunks = 0